import { createSlice } from '@reduxjs/toolkit'
import { deleteOriginalUser, setData, setOriginalUser, setRoles, setSelectedTableRows } from '../reducers/userReducers'

type UserState = {
  name: string
  email: string
  userId: string
  firstName: string
  lastName: string
  siteId: number
  roles: string[]
  selectedTableRows: Record<string, Array<Record<string, unknown>>>
  originalUser?: {
    userId: string
    name: string
    firstName: string
    lastName: string
    email: string
  }
}

const initialState: UserState = {
  name: '',
  email: '',
  userId: '',
  firstName: '',
  lastName: '',
  siteId: 0,
  roles: [],
  selectedTableRows: {},
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setData,
    setRoles,
    setOriginalUser,
    deleteOriginalUser,
    setSelectedTableRows,
  },
})

export type { UserState }
export const userActions = userSlice.actions
export default userSlice.reducer
